import React, { useEffect, useRef } from 'react';

interface IFootnoteRefProps {
    id: string;
    target: string;
    dark?: boolean;
    children: React.ReactNode;
    onClick?: () => void;
}

export const FootnoteRef: React.FC<IFootnoteRefProps> = ({
    id,
    target,
    dark,
    children,
    onClick
}) => {
    const ref = useRef(null);

    useEffect(() => {
        ref.current.addEventListener('dsdFootnoteRefClick', () => {
            if (onClick) onClick();
        });
    }, []);

    return (
        <>
            {/*@ts-ignore*/}
            <dsd-footnote-ref target={target} id={id} dark={dark} ref={ref}>
                {children}
                {/*@ts-ignore*/}
            </dsd-footnote-ref>
        </>
    );
};
